var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTemplate = function SvgTemplate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.1879 22H4.18787C3.92265 22 3.6683 21.8946 3.48076 21.7071C3.29322 21.5196 3.18787 21.2652 3.18787 21V3C3.18787 2.73478 3.29322 2.48043 3.48076 2.29289C3.6683 2.10536 3.92265 2 4.18787 2H20.1879C20.4531 2 20.7074 2.10536 20.895 2.29289C21.0825 2.48043 21.1879 2.73478 21.1879 3V21C21.1879 21.2652 21.0825 21.5196 20.895 21.7071C20.7074 21.8946 20.4531 22 20.1879 22ZM19.1879 20V4H5.18787V20H19.1879ZM7.18787 6H11.1879V10H7.18787V6ZM7.18787 12H17.1879V14H7.18787V12ZM7.18787 16H17.1879V18H7.18787V16ZM13.1879 7H17.1879V9H13.1879V7Z"
  })));
};
export default SvgTemplate;